"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const fortunes_1 = __importDefault(require("store/fortunes"));
const app_1 = require("ui/app");
const presets_1 = __importDefault(require("./store/presets"));
function createContainer() {
    const div = document.createElement("div");
    div.id = "react-container";
    document.body.appendChild(div);
    return div;
}
function findContainer() {
    var _a;
    return (_a = document.querySelector("#react-container")) !== null && _a !== void 0 ? _a : createContainer();
}
window.addEventListener("load", () => {
    presets_1.default.load();
    fortunes_1.default.load(presets_1.default.current);
    react_dom_1.render(react_1.default.createElement(app_1.App, null), findContainer());
    mobx_1.autorun(() => {
        document.body.style.background = fortunes_1.default.background;
        fortunes_1.default.save();
    });
});
const favIcon = "AAABAAEAEBAAAAEAIABoBAAAFgAAACgAAAAQAAAAIAAAAAEAIAAAAAAAAAQAABILAAASCwAAAAAAAAAAAAAAAAAAAAAAAAqSlwAAkokDF4inMzeOtIoRVKnJGVGs43OryONqrMTIHnatiQ6ApzIEeIkDBnaUAAAAAAAAAAAAABUEABOKpwAOj6EOGHGqd4i2zd7A0OD8Mza5/yQktv/T0+f/w8fj/x0ssfwWRKzdN5G2dgB6nw4KgKcAAAAAAAp+owAOjqEODV2nlgoiqvmCgdH/8O/u/2lpy/8mJrf/0dHj/5eW1/8RELH/cnLN/73V3flVpr+VAHyfDhONrAAAAAcBSKK5eIaez/krKbn/IiK2/7u73f+goNX/MTG5/8vL4v9eXsb/Ozu9/9ra6v/W1Oj/RV28+QhjqHYJ/3oBBXijNISyzN7u7ez/vb3h/zg4vP9SUsL/xcXl/01Nwf+/v+f/Nja7/66u4v/Pz+z/QUG//w4Or/8ZR63dG5CsMwxjp4onNrT8eXjQ/8XF4P/Dw93/VFTA/4qK1v98e8//jIzW/29vzf+ysuP/Nze7/zAwuv9+fdH/rr7a/Emhu4kdX63IHyK0/xkZs/8iIrf/XV3D/5ub1f9zcsz/dnvG/3B1xf+FhdL/VVXF/5GR1v/NzeD/5eXp/9PX5P9eoMHIebDJ48vM5P+3t97/lpbS/3p6zv9xcc7/dHjF/zWFsP87ksP/cnjH/4qK1f99fdH/W1vF/0dHwP8vMLj/GFSp43eux+TIyOL/srLc/5WV0f+Bgc//cnLN/3R5x/8ygqr/NYix/3V7yf+NjNb/e3vP/1paxP9HR8D/LzC5/xhVq+EbXavKHSGz/xQUsv8rK7j/cXHK/6am3v91dc3/dnzJ/3B2x/+EhNL/V1fG/5SU1f/S0uL/5ubq/9XY5v9fosPGDGKljCo6tfx9fNH/ycni/8LC3/9XV8T/hYXK/2lpx/+KitX/c3PO/6mp2/8/P7z/QkK+/4eG0/+ywtz8SqK9iAV3oTSFs83e7e3r/7m53/81Nbv/VVXD/7i42f89Pb3/ubnh/z4+vP+oqNf/wcHf/0dHwP8bG7L/HUyu3RuSrzIAAAYBSKG4eIKbzvkpJ7j/JSW3/8DA3/+cnNX/MjK6/8nJ3/9YWMT/PT2+/9jY5v/R0Ob/RFy7+QlkqXYB/4gBCn6jAA6OoA4MXKeWDSWr+YeH0//r6+r/ZGTJ/ykpuP/V1eb/kpLV/w8Osf93ds7/vdbd+VSlv5QAfKAOE46sAAAhBAAUi6gADY+hDhlzq3eJt83evcze/DAzuP8nJ7f/1NTm/7/C4P8ZKLD8FkWs3TmStnYAeZ4OCoCnAAAHAAAAAAAAAAAAAAmSmAAAkYsDGImpMzaNtIoQU6nJGlKt43WtyeNpq8TIHXSsiQ5/pjIDcoUDBXGRAAAAAAAAAAAA4AcAAMADAACAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIABAADAAwAA4AcAAA==";
const newLink = document.createElement('link');
newLink.rel = 'shortcut icon';
newLink.type = 'image/x-icon';
newLink.href = 'data:image/x-icon;base64,' + favIcon;
document.head.appendChild(newLink);
/* Other JS would also be in here */
